import { Link } from "react-router-dom";

const nav = [
  { label: "首页", to: "/" },
  { label: "番剧检索", to: "/sousuo" },
  { label: "关于我们", to: "/guanyu" },
];

const hot = ["高口碑榜单", "剧场版专区", "OVA 番外", "本季新番", "经典神作", "隐藏目录"];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-cup-line text-xl"></i>
              </span>
              <span className="font-heading text-2xl font-bold text-background-50">牛奶动漫库</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-background-300">
              用年份、评分与标签，帮你一秒定位想看的番。汇集各季新番、剧场版与 OVA 番外，做最懂你的动漫检索库。
            </p>
            <div className="mt-5 flex items-center gap-3 text-background-300">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-tv-2-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">站点导航</h4>
            <ul className="mt-4 space-y-3">
              {nav.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-background-300 transition-colors hover:text-primary-400">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">热门栏目</h4>
            <ul className="mt-4 space-y-3">
              {hot.map((item) => (
                <li key={item}>
                  <Link to="/sousuo" className="text-sm text-background-300 transition-colors hover:text-primary-400">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-700 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 牛奶动漫库 · 用心收录每一部好番</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-mail-line"></i> contact@milk-anime.example
          </p>
        </div>
      </div>
    </footer>
  );
}